import llm from './llm_client'
import { Message } from './backend'
import { get } from './preferences'

export async function getModels() {
    const llmProvider = 'Convolution'; //await get("llmProvider")
    const key = await get(llmProvider + 'ApiKey')
    return await llm.getModels(llmProvider, key)
}

export async function getResponse(instruction: string) {
    const llmProvider = 'Convolution'; //await get("llmProvider")
    const key = await get(llmProvider + 'ApiKey')
    const model = await get(llmProvider + 'Model')

    return await llm.getResponse(llmProvider, key, model, instruction)
}

export async function speechGetResponse(voice: string) {
    const sttProvider = 'Convolution'; // await get("sttProvider")
    const key = await get(sttProvider + 'ApiKey')
    const model = await get(sttProvider + 'Model')

    return await llm.speechGetResponse(sttProvider, key, model, voice)
}